export const SectionTag = ({ children, light }) => (
  <p className={`sr-label sr-red-rule ${light ? "text-[#9DC1F5]" : ""}`}>{children}</p>
);

export const PageHero = ({ tag, title, accent, children, image }) => (
  <section className="relative overflow-hidden bg-white border-b border-slate-200">
    {image && <img src={image} alt="" className="absolute inset-y-0 right-0 w-1/2 h-full object-cover opacity-20 hidden lg:block" />}
    <div className="max-w-7xl mx-auto px-4 lg:px-8 py-16 lg:py-20 relative">
      <SectionTag>{tag}</SectionTag>
      <h1 className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase tracking-tight leading-[0.95] text-[#0B1F4B] max-w-3xl">
        {title} {accent && <span className="text-[#1E7CF2]">{accent}</span>}
      </h1>
      {children && <div className="mt-6 max-w-2xl text-slate-600 text-sm sm:text-base leading-relaxed">{children}</div>}
    </div>
  </section>
);

export const IconStat = ({ icon: Icon, title, sub, testId }) => (
  <div className="flex flex-col items-center text-center gap-3" data-testid={testId}>
    <div className="sr-ring-icon"><Icon size={22} /></div>
    <p className="text-xs font-bold uppercase tracking-wider text-[#0B1F4B]">{title}</p>
    {sub && <p className="text-xs text-slate-500 -mt-2">{sub}</p>}
  </div>
);
